<template>
  <div class="ind_foo1">
    <div class="foot_bg_box">
        <div class="foot_mask"></div>
        <div class="ind_foo_n">
          <img src="../../static/img/logo.png" alt="" class="footLogo">
          <div class="ind_foo_t">
          <div class="ind_foo_t_l">

              <div class="ind_foo_t_l_a">北京知诚教育科技有限公司</div>
              <div class="ind_foo_t_l_b">本公司主要从事论文相似度查重业务,旗下CopyCheck是中文学术论文相似度查重系统，是可信赖的中文剽窃检查的在线网站。</div>
              <div class="ind_foo_t_l_c">公司地址:北京市顺义区裕曦路9号院9号楼9层2-1902</div>
              <div class="ind_foo_t_l_d">客服QQ:535659836 <span></span><span></span><span></span> 电话:010-80495775</div>
          </div>
          <div class="ind_foo_t_r">
            <div class="mp_outter">
              <div class="mp_img_outter">
                <img src="../../static/img/icon1.jpg" />
              </div>
              <p>微信公众号</p>
            </div>
          </div>
        </div>
          <div class="ind_foo_b" ref="ind_foo"><span class="ind_foo_b_sp">CopyCheck论文查重©2024 All Rights Reserved . </span><span class="beian" @click="beian" href="//www.beian.miit.gov.cn" target="_blank"><span class="ind_foo_b_sp">京ICP备18060044号-7</span></span></div>
        </div>
    </div>
  </div>
</template>

<script>
import { siteInfos } from "../assets/js/common"

export default {
  name: 'index-footer',
  data () {
    return {
      toggle:false,
      domain:siteInfos.domain,
    }
  },
	methods: {
		beian: function(){
			window.open('http://beian.miit.gov.cn');
		},
    calcSizeWidthHeight(num) {
      return document.body.clientWidth*(num/1903);
    },
    styleInit() {
      $('.ind_foo_t_l').css('margin-top', this.calcSizeWidthHeight(39)+"px");

      $('.ind_foo_n').css('width', this.calcSizeWidthHeight(1388)+"px");
      $('.ind_foo_b').css('height', this.calcSizeWidthHeight(65)+"px");
      $('.ind_foo_b').css('line-height', this.calcSizeWidthHeight(65)+"px");
      $('.foot_bg_box').css('height', this.calcSizeWidthHeight(369)+"px");

      $('.ind_foo_b_sp_img').css('width', this.calcSizeWidthHeight(80)+"px");
      $('.ind_foo_b_sp_img').css('margin-left', this.calcSizeWidthHeight(10)+"px");
      $('.ind_foo_b_sp_img').css('top', this.calcSizeWidthHeight(8)+"px");

      $('.footLogo').css('width', this.calcSizeWidthHeight(284)+"px");
      $('.footLogo').css('height', this.calcSizeWidthHeight(28)+"px");
      $('.footLogo').css('margin-top', this.calcSizeWidthHeight(55)+"px");

      $('.ind_foo_t_l_a').css('font-size', this.calcSizeWidthHeight(16)+"px");
      $('.ind_foo_t_l_a').css('height', this.calcSizeWidthHeight(16)+"px");
      $('.ind_foo_t_l_a').css('line-height', this.calcSizeWidthHeight(16)+"px");

      $('.ind_foo_t_l_b').css('height', this.calcSizeWidthHeight(28)+"px");
      $('.ind_foo_t_l_b').css('font-size', this.calcSizeWidthHeight(14)+"px");
      $('.ind_foo_t_l_b').css('line-height', this.calcSizeWidthHeight(28)+"px");

      $('.ind_foo_t_l').css('width', this.calcSizeWidthHeight(780)+"px");

      $('.ind_foo_t_l_c').css('margin-top', this.calcSizeWidthHeight(40)+"px");
      $('.ind_foo_t_l_c').css('font-size', this.calcSizeWidthHeight(14)+"px");
      $('.ind_foo_t_l_c').css('line-height', this.calcSizeWidthHeight(14)+"px");

      $('.ind_foo_t_l_d').css('height', this.calcSizeWidthHeight(14)+"px");
      $('.ind_foo_t_l_d').css('font-size', this.calcSizeWidthHeight(14)+"px");
      $('.ind_foo_t_l_d').css('line-height', this.calcSizeWidthHeight(14)+"px");
      $('.ind_foo_t_l_d').css('margin-top', this.calcSizeWidthHeight(19)+"px");

      $('.ind_foo_t_r').find('.mp_outter').css('width', this.calcSizeWidthHeight(134)+"px");
      $('.ind_foo_t_r').find('.mp_outter').css('height', this.calcSizeWidthHeight(173)+"px");

      $('.ind_foo_t_r').find('.mp_outter').find('.mp_img_outter').css('width', this.calcSizeWidthHeight(134)+"px");
      $('.ind_foo_t_r').find('.mp_outter').find('.mp_img_outter').css('height', this.calcSizeWidthHeight(134)+"px");
      $('.ind_foo_t_r').find('.mp_outter').find('.mp_img_outter').css('border-radius', this.calcSizeWidthHeight(6)+"px");
      $('.ind_foo_t_r').find('.mp_outter').find('.mp_img_outter').css('padding', this.calcSizeWidthHeight(12)+"px");

      $('.ind_foo_t_r').find('.mp_outter').find('img').css('width', this.calcSizeWidthHeight(111)+"px");
      $('.ind_foo_t_r').find('.mp_outter').find('img').css('height', this.calcSizeWidthHeight(111)+"px");

      $('.ind_foo_t_r').find('.taobao_outter').css('width', this.calcSizeWidthHeight(134)+"px");
      $('.ind_foo_t_r').find('.taobao_outter').css('height', this.calcSizeWidthHeight(173)+"px");

      $('.ind_foo_t_r').find('.taobao_img_outter').css('width', this.calcSizeWidthHeight(134)+"px");
      $('.ind_foo_t_r').find('.taobao_img_outter').css('height', this.calcSizeWidthHeight(134)+"px");
      $('.ind_foo_t_r').find('.taobao_img_outter').css('border-radius', this.calcSizeWidthHeight(6)+"px");

      $('.ind_foo_t_r').find('.taobao_img_outter').find('img').css('width', this.calcSizeWidthHeight(134)+"px");
      $('.ind_foo_t_r').find('.taobao_img_outter').find('img').css('height', this.calcSizeWidthHeight(134)+"px");

      $('.ind_foo_t_r').find('div').find('p').css('height', this.calcSizeWidthHeight(14)+"px");
      $('.ind_foo_t_r').find('div').find('p').css('font-size', this.calcSizeWidthHeight(14)+"px");
      $('.ind_foo_t_r').find('div').find('p').css('line-height', this.calcSizeWidthHeight(14)+"px");
      $('.ind_foo_t_r').find('div').find('p').css('margin-top', this.calcSizeWidthHeight(159)+"px");

      $('.ind_foo').css('height', this.calcSizeWidthHeight(369)+"px");
      $('.ind_foo_n').css('height', this.calcSizeWidthHeight(369)+"px");

      $('.ind_foo_t').css('margin-top', this.calcSizeWidthHeight(30)+"px");
      $('.ind_foo_t').css('padding-bottom', this.calcSizeWidthHeight(35)+"px");

      $('.ind_foo_t_r').find('.mp_outter').css('margin-right', this.calcSizeWidthHeight(0)+"px");
    }
	},
  mounted(){
    window.onresize = () => {
      return (() => {
        this.styleInit();
      })()
    }
    this.styleInit();
  }
}
</script>

<style scoped>
.ind_foo1{
  width: 100%;
  height: auto;
  background-image: url(../../static/img/qiye/foot_bg.png);
  background-size: 100%;
  background-repeat:no-repeat;
  box-sizing: border-box;
}
.ind_foo_t_l{
  margin-top:39px;
}
.ind_foo_n{
  max-width:unset !important;
  width:1388px;
  position:relative;
  z-index:2;
}
.foot_mask{
  width:100%;
  height:100%;
  position:absolute;
  left:0px;
  top:0px;
  background:red;
  z-index:1;
  background: #1F3428;
  opacity: 0.8;
}
.beian{
	cursor:pointer;

}
.beian:hover{
	text-decoration: underline;
}
.ind_foo_b{
	opacity:1 !important;
	height:65px;
  line-height: 65px;
}
.foot_bg_box{
  width: 100%;
  height: 368px;
}
.ind_foo_b_sp{
}
.ind_foo_b_sp_img{
	width: 80px;
    margin-left: 10px;
    position: relative;
    top: 8px;
}
.footLogo{
  width: 284px;
  height: 28px;
  margin-top:55px;
  float:left;
}
.ind_foo_t_l_a{
  font-size: 16px;
  font-family: PingFangSC-Regular,微软雅黑;
  font-weight: 400;
  color: #FFFFFF;
  height:16px;
  line-height: 16px;
}
.ind_foo_t_l_b{
  height: 28px;
  font-size: 14px;
  font-family: PingFangSC-Regular,微软雅黑;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 28px;
}
.ind_foo_t_l{
  width:780px;
}
.ind_foo_t_l_c{
  margin-top:40px;
  font-size: 14px;
  height:14px;
  font-family: PingFangSC-Regular,微软雅黑;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 14px;
}
.ind_foo_t_l_d{
  height: 14px;
  font-size: 14px;
  font-family: PingFangSC-Regular,微软雅黑;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 14px;
  margin-top:19px;
}
.ind_foo_t_r{
  overflow:hidden;
}
.ind_foo_t_r .mp_outter{
  width: 134px;
  height: 173px;
  overflow:hidden;
}
.ind_foo_t_r .mp_outter .mp_img_outter{
  width: 134px;
  height: 134px;
  box-sizing:border-box;
  background: #FFFFFF;
  border-radius: 6px;
  overflow:hidden;
  padding:12px;
}

.ind_foo_t_r .mp_outter img{
  width: 111px;
  height: 111px;
  display:block;
  float:left;
}

.ind_foo_t_r .taobao_outter{
  width: 134px;
  height: 173px;
  box-sizing:border-box;
  overflow:hidden;
}
.ind_foo_t_r .taobao_img_outter{
  width: 134px;
  height: 134px;
  overflow:hidden;
  background: #FFFFFF;
  border-radius: 6px;
}
.ind_foo_t_r .taobao_img_outter img{
  width: 134px;
  height: 134px;
}
.ind_foo_t_r div p{
  height: 14px;
  font-size: 14px;
  height:14px;
  font-family: PingFangSC-Regular,微软雅黑;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 14px;
  margin-top:159px;
}
.foot_bg_box{
  position:relative;
}

</style>



// WEBPACK FOOTER //
// src/components/Footerr.vue